import api from "../../utils/apiUserTienda";


export const getPedidos = async ({
  limit = 50,
  cursor = null,
  estado = null,
  pago = null,
  mes = null,
} = {}) => {
  const params = new URLSearchParams();
  params.set("limit", String(limit));
  if (cursor) params.set("cursor", cursor);
  if (estado) params.set("estado", estado);
  if (pago) params.set("pago", pago);
  if (mes) params.set("mes", mes);

  const res = await api.get(`/api/tienda/pedidos/obtener?${params.toString()}`);
  return res.data; 
};

export const getPedidosResumen = async ({ mes = null } = {}) => {
  const params = new URLSearchParams();
  if (mes) params.set("mes", mes);
  const query = params.toString();
  const res = await api.get(
    `/api/tienda/pedidos/obtener/resumen${query ? `?${query}` : ""}`
  );
  return res.data;
};

export const getPedidoById = async (pedido_id) => {
  const res = await api.get(`/api/tienda/pedidos/obtener/${pedido_id}`);
  return res.data;
};

export const updateEstadoPedido = async (pedido_id, payload) => {
  const res = await api.put(`/api/tienda/pedidos/actualizar/${pedido_id}/estado`,payload);
  return res.data;
};

export const confirmarPagoPedido = async (pedido_id) => {
  const res = await api.post(`/api/tienda/pedidos/actualizar/${pedido_id}/pago/confirmar`);
  return res.data;
};

export const getPedidoHistorial = async (pedido_id) => {
  const res = await api.get(`/api/tienda/pedidos/obtener/${pedido_id}/historial`);
  return res.data;
};

export const crearPedidoManual = async (payload) => {
  const res = await api.post("/api/tienda/pedidos/crear", payload);
  return res.data;
};

// Envía (o reenvía) el correo de resumen del pedido al cliente.
export const enviarCorreoPedido = async (pedido_id) => {
  const res = await api.post(`/api/tienda/pedidos/actualizar/${pedido_id}/correo`);
  return res.data;
};
